import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { SeoService } from '../../core/services/seo.service';
import { SiteConfigService } from '../../core/config/site-config.service';
@Component({
  selector: 'app-expertise-detail',
  standalone: true,
  imports: [RouterLink],
  template: `
    @if (item) {
      <!-- Hero -->
      <section class="relative py-24 md:py-32 -mt-20 pt-32 md:pt-40 overflow-hidden">
        <img [src]="item.image" [alt]="item.title" class="absolute inset-0 w-full h-full object-cover" />
        <div class="absolute inset-0 bg-surface-950/70"></div>
        <div class="mx-auto max-w-7xl px-6 lg:px-8 relative z-10">
          <a routerLink="/expertise" class="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white mb-6 transition-colors">
            <svg aria-hidden="true" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" /></svg>
            Back to Expertise
          </a>
          <span class="text-[0.65rem] font-bold uppercase tracking-wider text-brand-300">{{ item.category }}</span>
          <h1 class="font-heading text-3xl md:text-4xl font-extrabold text-white leading-tight tracking-tight mt-2">{{ item.title }}</h1>
        </div>
      </section>

      <!-- Content -->
      <section class="py-16 md:py-24 bg-white">
        <div class="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <div class="grid grid-cols-1 lg:grid-cols-5 gap-12">
            <div class="lg:col-span-3">
              <p class="text-lg text-surface-600 leading-relaxed mb-8">{{ item.description }}</p>
              @if (item.features && item.features.length) {
                <h2 class="font-heading text-xl font-bold text-surface-900 mb-4">What We Offer</h2>
                <ul class="space-y-3">
                  @for (feature of item.features; track $index) {
                    <li class="flex items-start gap-3 text-surface-600">
                      <svg aria-hidden="true" class="w-5 h-5 text-brand-600 shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" /></svg>
                      {{ feature }}
                    </li>
                  }
                </ul>
              }
            </div>
            <div class="lg:col-span-2">
              <div class="rounded-xl overflow-hidden sticky top-24">
                <img [src]="item.image" [alt]="item.title" class="w-full aspect-[3/4] object-cover" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- CTA -->
      <section class="py-16 bg-brand-600">
        <div class="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 text-center">
          <h2 class="font-heading text-2xl md:text-3xl font-bold text-white mb-5">Ready for Your Project?</h2>
          <p class="text-brand-100 mb-7 max-w-lg mx-auto">Get a free consultation with our specialists.</p>
          <a routerLink="/contact" class="inline-flex items-center gap-2 px-7 py-3.5 bg-white text-brand-700 font-semibold text-sm rounded-lg hover:bg-brand-50 transition-colors">
            Get Free Estimate
          </a>
        </div>
      </section>
    } @else {
      <section class="py-32 text-center">
        <h1 class="font-heading text-2xl font-bold text-surface-900 mb-4">Expertise Not Found</h1>
        <a routerLink="/expertise" class="text-brand-600 hover:text-brand-700 font-semibold">Back to Expertise</a>
      </section>
    }
  `,
})
export class ExpertiseDetailComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private seo = inject(SeoService);
  private config = inject(SiteConfigService);

  item: any;

  ngOnInit(): void {
    const slug = this.route.snapshot.paramMap.get('slug');
    const expertise = this.config.pages.expertise;
    if (expertise) {
      this.item = expertise.items.find(i => i.slug === slug);
      if (this.item) {
        this.seo.setTitle(this.item.title);
        this.seo.setDescription(this.item.description);
      }
    }
  }
}
